import { Transforms, Editor } from 'slate';
import { ReactEditor } from 'slate-react';
import { toggleBlock } from './utilities';

function resetRichText(editor: ReactEditor, originalValue: any) {
  // (note - pearl) Select all in the editor
  Transforms.select(editor, {
    anchor: Editor.start(editor, []),
    focus: Editor.end(editor, []),
  });

  // (note - pearl) Transform all to paragraph, otherwise delete won't work
  toggleBlock(editor, 'paragraph');

  // (note - pearl) Insert empty line at the end so all paths have elements
  Transforms.insertNodes(editor, { children: [{ text: '' }] }, { at: [editor.children.length] });

  // (note - pearl) Delete all content
  Transforms.delete(editor, {
    at: {
      anchor: {
        path: [0, 0],
        offset: 0,
      },
      focus: {
        path: [editor.children.length - 1, 0],
        offset: 0,
      },
    },
  });

  // (note - pearl) Add original content. insertFragment instead of insertNodes so it's not
  // wrapped in an extra children object on the outside
  Transforms.insertFragment(editor, originalValue, {
    at: [0, 0],
  });

  Transforms.deselect(editor);
}

export default resetRichText;
